import React, { useEffect } from 'react';
import Header from './Header';
import Footer from './Footer';
import { setFavicon } from '../utils/helpers';
import './Layout.css';

function Layout({ children, title, favicon }) {
  useEffect(() => {
    if (title) document.title = title;
    if (favicon) setFavicon(favicon);
  }, [title, favicon]);

  return (
    <div className="layout">
      <Header />
      <main className="layout__content">
        {children}
      </main>
      <Footer />
    </div>
  );
}

export default Layout;
